import { observer } from 'mobx-react';
import { Avatar, avatarFrom } from '../../../../../../../../Avatar';
import { findLink } from '../../../../../../../../LinkyLinky';
import ParticipantStore from '../../../../../../../../ParticipantStore';
import { Link } from '../../../../../../../../Resource/Types';
import PersonPhoto from '../../../../../../../PersonPhoto';

interface Props {
  store: ParticipantStore;
}

const getAvatar = (photo: ReadonlyArray<Link>, store: ParticipantStore): Avatar =>
  avatarFrom(findLink('avatar', photo), store.resource.payload.initials);

function Row({ store }: Props) {
  return (
    <div className="flex pt-2 justify-between items-center">
      <div className="flex">
        <div className="w-10 h-10 mr-2 my-auto">
          <div className="flex" data-test-person={true}>
            <div
              className="relative h-10 w-10 min-w-[100%] rounded-full bg-[#187A90]"
              data-test-person-avatar={true}
            >
              <PersonPhoto avatar={getAvatar(store.resource.links, store)} />
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="">{store.resource.payload.fullName.getOrElseValue('')}</div>
          <div className="">{store.resource.payload.email}</div>
        </div>
      </div>
    </div>
  );
}

export default observer(Row);
